import script from "./FlipCardComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FlipCardComponent.vue?vue&type=script&setup=true&lang=js"

import "./FlipCardComponent.vue?vue&type=style&index=0&id=b2510d1a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2510d1a"]])

export default __exports__